// extracted by mini-css-extract-plugin
export default {"commentsTab__commentsList":"styles_comments-tab__comments-list__zVTKi","commentsTab__newComment":"styles_comments-tab__new-comment__-qaH2"};